export interface CheckPaymentStatusResponse {
    isPayed: boolean;
    isPending: boolean;
    isError: boolean;
    errorMessage?: string;
}
